import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TDynamicQuery {
  code: string;
  description: string;
  sqlQuery: string;
}

export interface IDynamicQuery extends TDynamicQuery {}

const DynamicQuery = Model(
  (model: TDynamicQuery): IDynamicQuery => {
    const _dynamicQuery: TDynamicQuery = Object.assign({}, model);

    let create = (dynamicQuery: IDynamicQuery): IDynamicQuery => {
      let obj = ValidatableObject(dynamicQuery);
      return obj;
    };

    let dynamicQuery = {
      get code() {
        return _dynamicQuery.code;
      },
      set code(value) {
        _dynamicQuery.code = value;
      },
      get description() {
        return _dynamicQuery.description;
      },
      set description(value) {
        _dynamicQuery.description = value;
      },
      get sqlQuery() {
        return _dynamicQuery.sqlQuery;
      },
      set sqlQuery(value) {
        _dynamicQuery.sqlQuery = value;
      }
    };

    return create(dynamicQuery);
  }
);

export default DynamicQuery;
